var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-outer fill-body",attrs:{"id":"app"}},[(!_vm.hideHeaderFooter)?_c('navigation-topbar'):_vm._e(),_c('main',{staticClass:"app-content fill-body"},[_c('router-view')],1),(!_vm.hideHeaderFooter)?_c('navigation-footer',{attrs:{"id":"footer"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }